import {
	DeleteMasterOrderMutation,
	EditMasterOrderMutation,
	InitializeMasterOrderMutation,
	UpdateMasterOrderStatusMutation
} from "~/gql/mutations/masterOrders.generated";
import { GetMasterOrderQuery, GetMasterOrdersQuery } from "~/gql/queries/masterOrder.generated";
import { GetOrdersGridListQuery } from "~/gql/queries/order.generated";

export const masterOrdersEndpoints = {
	DeleteMasterOrder: {
		invalidatesTags: ["MasterOrders"] as AddTagTypes,
		transformResponse: (res: DeleteMasterOrderMutation) => res
	},
	EditMasterOrder: {
		invalidatesTags: ["MasterOrders"] as AddTagTypes,
		transformResponse: (res: EditMasterOrderMutation) => res
	},
	GetMasterOrder: {
		providesTags: ["MasterOrders"] as AddTagTypes,
		transformResponse: (res: GetMasterOrderQuery) => res
	},
	GetMasterOrders: {
		providesTags: ["MasterOrders"] as AddTagTypes,
		transformResponse: (res: GetMasterOrdersQuery) => res
	},
	GetMasterOrdersGridList: {
		providesTags: ["MasterOrders"] as AddTagTypes,
		transformResponse: (res: GetOrdersGridListQuery) => res
	},
	InitializeMasterOrder: {
		invalidatesTags: ["MasterOrders"] as AddTagTypes,
		transformResponse: (res: InitializeMasterOrderMutation) => res
	},
	UpdateMasterOrderStatus: {
		invalidatesTags: ["MasterOrders"] as AddTagTypes,
		transformResponse: (res: UpdateMasterOrderStatusMutation) => res
	}
};
